/* eslint-disable max-len */
import { computed, onMounted } from 'vue-demi';
import { goUse, SHARE_COUOPN_BTN_TXT } from '../../../business';
import { ShareCouponStatus, ShareCouponInfo } from '@tencent/wphk-act-base-cgi';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';

/**
 * 券信息
 */
export const useCoupon = (couponInfo: ShareCouponInfo, emit) => {
  console.log('useCoupon couponInfo: ', couponInfo);
  /**
   * 券状态： 未开始 已结束 已派完 已领取 可领取
   */
  /** 是否展示，活动未开始、活动已结束不展示 */
  const isShow = computed(() => couponInfo && ![ShareCouponStatus.notStart, ShareCouponStatus.end].includes(couponInfo.status));
  /** 按钮文案 */
  const btnTxt = computed(() => SHARE_COUOPN_BTN_TXT[couponInfo.status]);
  /** 按钮灰色 */
  const isBtnGrey = computed(() => !isShow.value || couponInfo.status === ShareCouponStatus.soldOut);
  /** 点击按钮 */
  const onClick = () => {
    biClick('share_coupon.click', {
      fcouponid: couponInfo.couponId,
      fstatus: couponInfo.status,
    });
    if (!isShow.value) return;
    // 去使用
    if (couponInfo.status === ShareCouponStatus.received && couponInfo.userCouponId) {
      goUse(couponInfo.couponType, couponInfo.userCouponId);
      return;
    }
    emit('onClick');
  };
  onMounted(() => {
    biBrow('share_coupon.module_brow', { fcouponid: couponInfo.couponId });
  });
  return {
    /** 是否展示，活动未开始、活动已结束不展示 */
    isShow,
    /** 按钮文案 */
    btnTxt,
    /** 按钮灰色 */
    isBtnGrey,
    /** 点击按钮 */
    onClick,
  };
};
